import { Divider, Card, Button, Popconfirm } from "antd";
import { SaveOutlined, DeleteOutlined } from "@ant-design/icons";
import Details from "./details";

export default function EditEntry({ onDelete, loading }) {
  return (
    <Card bordered={false}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-2">
        <div className="col-span-12">
          <Details />
        </div>
      </div>
      <Divider />
      <div className="flex justify-between items-center">
        <Button
          loading={loading}
          type="primary"
          icon={<SaveOutlined />}
          htmlType="submit"
        >
          Save
        </Button>
        <Popconfirm
          okText="Yes, delete"
          title="Delete this entry?"
          description="This entry will be deleted, you won't be able to restore it."
          onConfirm={onDelete}
        >
          <Button
            disabled={loading}
            type="text"
            icon={<DeleteOutlined />}
            danger
          >
            Delete
          </Button>
        </Popconfirm>
      </div>
    </Card>
  );
}
